export const log = (label, data) => {
    // only log to console on non-prod envs
    if(process.env.REACT_APP_ENV !== 'prod') {
        console.log(label, data)
    }
}